<template>
  <baidu-map 
    class="bm-view" 
    :ak="ak"  
    :center="mapObj.startPoint"
    scroll-wheel-zoom
		:zoom="17"
    @ready="handler"
    @click="mapObj.limits?'':handleMapClick($event)">
    <!-- 搜索 -->
    <bm-control :offset="{width:10,height:10}">
      <el-input v-model.lazy="keyword" :placeholder="$t('placeholder.search')" clearable></el-input>
      <bm-local-search :keyword="keyword" :auto-viewport="true" :panel="false"></bm-local-search>
    </bm-control>
		<!-- 定位 -->
    <bm-geolocation 
      anchor="BMAP_ANCHOR_BOTTOM_RIGHT" 
      :showAddressBar="true"
      @locationSuccess="locationSuccess">
    </bm-geolocation>
    <!-- 起点 -->
    <bm-marker 
      v-if="mapObj.limits"
      @click="handleStartMarkerClick"
      :position="mapObj.nearBy.center">     
    </bm-marker>
    <!-- 终点 -->    
    <bm-marker 
      :title="mapObj.startContent"
      :position="mapObj.startPoint" 
      :dragging="mapObj.manualLoc"
      @click="handleEndMarkerClick"
      @dragend="endPointDragend"
      @dragstart="handleDragStart">    
      <!-- 提示框 -->
      <bm-info-window 
        :show="endWindowShow"
        @close="endWindowShow=false" 
        @open="endWindowShow=true">
        <el-form style="padding-top:20px" size="mini" label-width="40px">
          <el-form-item :label="$t('table.name')">
            <el-input :readonly="!mapObj.manualName" v-model="mapObj.startContent"></el-input>
          </el-form-item>
          <el-form-item v-if="mapObj.manualName" style="margin:0;text-align:right">
            <el-button type="primary" @click="endWindowShow=false">{{$t('buttons.determine')}}</el-button>
          </el-form-item>
        </el-form>
      </bm-info-window>   
    </bm-marker>    
    <!-- 区域 -->    
    <bm-circle 
      v-if="mapObj.limits"
      :center="mapObj.nearBy.center" 
      :radius="mapObj.nearBy.radius"
      strokeColor="#409EFF"
      :strokeWeight="3"
      fillColor="#409EFF"
      :fillOpacity="0.2"
      @click="handleMapClick">
    </bm-circle>      
  </baidu-map>  
</template>
<script>
import { mapGetters } from 'vuex'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import { BmContextMenuItem, BmContextMenu, BmControl, BmOverlay, BmGeolocation, BmMarker, BmlMarkerClusterer, BmWalking, BmLocalSearch, BmCircle, BmTraffic, BmDriving, BmTransit, BmInfoWindow } from 'vue-baidu-map'
export default {
  components: {
    BaiduMap,
    BmGeolocation,
    BmMarker,
    BmlMarkerClusterer,
    BmWalking,
    BmLocalSearch,
    BmCircle,
    BmTraffic,
    BmDriving,
    BmTransit,
    BmInfoWindow,
    BmOverlay,
    BmControl,
    BmContextMenu,
    BmContextMenuItem
  },
  props: {
    mapObj: {
      type: Object,
      default() {
        return {
          autoLoc: false,
          manualLoc: false,
          manualName: false,
          limits: false,
          nearBy: {
            center: {
              lng: 116.404, // 经度
              lat: 39.915 // 纬度
            },
            radius: 200
          },
          startPoint: {},
          nameMode:0,
          startContent: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters(['ak'])
  },
  watch: {
    'mapObj.startPoint'(newVal) {
      this.getLocationName(this.mapObj.startPoint).then(address => {
        this.mapObj.startContent = address
      })
    }
  },
  data() {
    return {
      keyword: '',
      BMap: undefined,
      map: undefined,
      clickNode: false,
      endWindowShow: false,
      dragStartPoint: undefined
    }
  },
  methods: {
    handleDragStart(e) {
      this.dragStartPoint = JSON.parse(JSON.stringify(this.mapObj.startPoint))
    },
    handleStartMarkerClick(e) {
      this.clickNode = true
      setTimeout(() => {
        this.clickNode = false
      }, 350)
    },
    // 点击终点显示弹出框
    handleEndMarkerClick() {
      this.clickNode = true
      this.endWindowShow = true
      setTimeout(() => {
        this.clickNode = false
      }, 350)
    },
    handler({ BMap, map }) {
      this.BMap = BMap
      this.map = map
      // if (this.mapObj.autoLoc) {
      //   const _this = this
      //   var geolocation = new BMap.Geolocation()
      //   geolocation.getCurrentPosition(function(r) {
      //     _this.mapObj.startPoint = r.point
      //     map.panTo(r.point)
      //   }, { enableHighAccuracy: true })
      // } else {
      if (!(this.mapObj.startPoint && this.mapObj.startPoint.lng && this.mapObj.startPoint.lat)) {
        const _this = this
        var geolocation = new BMap.Geolocation()
        geolocation.getCurrentPosition(function(r) {
          _this.mapObj.startPoint = r.point
          map.panTo(r.point)
        }, { enableHighAccuracy: true })
      }
      if (!this.mapObj.startContent) {
        this.getLocationName(this.mapObj.startPoint).then(address => {
          this.mapObj.startContent = address
        })
      }
      // }
    },
    // 终点拖动
    endPointDragend({ type, target, pixel, point }) {
      if (this.mapObj.manualLoc) {
        if (this.mapObj.limits) {
          const a = new this.BMap.Point(point.lng, point.lat)
          const b = new this.BMap.Point(this.mapObj.nearBy.center.lng, this.mapObj.nearBy.center.lat)
          const distance = this.map.getDistance(a, b)
          if (distance < this.mapObj.nearBy.radius) {
            this.mapObj.startPoint = point
            this.endWindowShow = true
          } else {
            this.mapObj.startPoint = { lnt: 0, lat: 0 }
            this.$nextTick(() => {
              this.mapObj.startPoint = JSON.parse(JSON.stringify(this.dragStartPoint))
            })
          }
        } else {
          this.mapObj.startPoint = point
          this.endWindowShow = true
        }
      }
    },
    // 点击设置终点
    handleMapClick({ type, target, point, pixel, overlay }) {
      if (!this.clickNode && this.mapObj.manualLoc) {
        this.mapObj.startPoint = point
        this.endWindowShow = true
      }
    },
    // 定位完成
    locationSuccess({ point, AddressComponent, marker }) {
      this.$nextTick(() => {
        this.mapObj.startPoint = point
      })
    },
    // 获取地名
    getLocationName(point) {
      var that=this
      return new Promise((resolve, reject) => {
        const a = new this.BMap.Point(point.lng, point.lat)
        const gc = new this.BMap.Geocoder({
          // extensions_town:true
        })
        gc.getLocation(a, function(rs) {
          console.log(rs)
          const addComp = rs.addressComponents
          const mapDistrict = addComp.province !== addComp.city? addComp.province + addComp.city + addComp.district:addComp.city + addComp.district
          if(that.mapObj.nameMode){
            // 街区
            resolve(mapDistrict+addComp.street+addComp.streetNumber)
          }else{
            // 商圈
            let addPlace=rs.business
            if(addPlace.indexOf(',')>=0){
              addPlace=addPlace.split(',')[0]
            }
            let surroundingPoint=(rs.surroundingPois&&rs.surroundingPois.length)?rs.surroundingPois[0]:null
            if(surroundingPoint){
              addPlace=surroundingPoint.title
            }
            resolve(mapDistrict+addPlace)
          }
        })
      })
    }
  }
}
</script>

<style>
.bm-view {
  width: 100%;
  height: 100vh;
}
</style>